import { ComponentProps } from 'react';



import { PATH_ICON } from '@/app/_constant/icons';
import { cn } from '@/app/_helper/tailwind';


const ArrowNavigationNext = ({
    className,
    svgClassName = 'text-accent',
    children,
    svgName = 'arrow-navigation-next-rounded',
    size = '40',
    ...props
}: { svgName?: string; svgClassName?: string; size?: string } & ComponentProps<'button'>) => {
    return (
        <button
            aria-label='arrow next'
            className={cn(
                'bg-transparent outline-none cursor-pointer md:inline-flex items-center justify-center hidden',
                className,
            )}
            {...props}
        >
            {children ? (
                children
            ) : (
                <svg
                    width={size}
                    height={size}
                    viewBox='0 0 40 40'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    className={svgClassName}
                >
                    <use
                        xlinkHref={`${PATH_ICON}SearchPageIcons.svg#${svgName}`}
                    />
                </svg>
            )}
        </button>
    );
};

export default ArrowNavigationNext;
